import React from "react";
import { 
  Box, 
  Text, 
  VStack, 
  Button,
  Flex,
} from "@chakra-ui/react";
import HeaderTools from "../../components/HeaderTools";

export default function DiscountCoupon() {
  const handleAddCoupon = () => {
    console.log("Adicionar cupom");
  };

  return (
    <Box 
      minH="100vh" 
      bg="gray.50"
      w="100%"
    >
      <HeaderTools title="Cupom de Desconto" />
      <Flex
        direction="column"
        align="center"
        justify="center"
        minH="calc(100vh - 80px)"
        px={{ base: 4, md: 6 }}
        py={{ base: 8, md: 12 }}
      >
        <VStack spacing={8} align="center" maxW="400px" w="100%">
          <Text
            as="h1"
            fontSize={{ base: "20px", md: "24px", lg: "28px" }}
            fontWeight="bold"
            color="gray.700"
            textAlign="center"
            lineHeight="1.4"
            px={4}
          >
            Você ainda não criou cupons de desconto
          </Text>
          <Button
            onClick={handleAddCoupon}
            bg="black"
            color="white"
            size="lg"
            fontSize={{ base: "16px", md: "18px" }}
            fontWeight="semibold"
            px={{ base: 8, md: 12 }}
            py={{ base: 6, md: 7 }}
            h={{ base: "50px", md: "56px" }}
            borderRadius="8px"
            _hover={{
              bg: "gray.800",
              transform: "translateY(-2px)",
              boxShadow: "lg"
            }}
            _active={{
              bg: "gray.900",
              transform: "translateY(0)"
            }}
            transition="all 0.2s ease-in-out"
            w={{ base: "100%", sm: "auto" }}
            minW={{ sm: "200px" }}
          >
            Adicionar cupom
          </Button>
        </VStack>
      </Flex>
    </Box>
  );
}